/* tslint:disable */
const iconData = `
<svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" fill="none"><path fill="currentcolor" fill-rule="evenodd" d="M8.5 0 5.729 5.069 0 6.112l4.015 4.175-.767 5.712L8.5 13.512 13.753 16l-.767-5.713 4.015-4.175-5.729-1.043L8.5 0ZM5.087 9.942 2.032 6.764l4.359-.793L8.5 2.114l2.11 3.857 4.359.793-3.055 3.178.584 4.347L8.5 12.397 4.502 14.29l.585-4.348Z" clip-rule="evenodd"/></svg>
`;
export default iconData;
